/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createElement } from 'react'
import ReactDOMServer from 'react-dom/server'

import { mdiFormatText } from '@mdi/js'
import Icon from '@mdi/react'
import { ElementFactory, QuestionHtmlModel, Serializer, SvgRegistry } from 'survey-core'
import { localization } from 'survey-creator-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'

import MarkDownConverter from '@components/molecules/MarkDownConverter'
import MarkDownRichTextEditor from '@components/molecules/MarkDownRichTextEditor'

import './styles.scss'

const CUSTOM_TYPE = 'markdown'

// A model for the new question type
export class QuestionMarkdownModel extends QuestionHtmlModel {
  getType() {
    return CUSTOM_TYPE
  }
  get markdown() {
    return this.getPropertyValue('markdown')
  }
  set markdown(val) {
    this.setPropertyValue('markdown', val)
  }
  setMarkdown(val: string) {
    this.setPropertyValue('markdown', val)
  }
}

// Register `QuestionMarkdownModel` as a model for the `text` type
export function registerMarkdownType() {
  ElementFactory.Instance.registerElement(CUSTOM_TYPE, (name) => {
    return new QuestionMarkdownModel(name)
  })
}

// Specify display names for the question type and its properties
const locale = localization.getLocale('')
locale.qt[CUSTOM_TYPE] = 'Text'

// Register an SVG icon for the question type
const svg = ReactDOMServer.renderToString(<Icon path={mdiFormatText} size={1} />)
SvgRegistry.registerIconFromSvg(CUSTOM_TYPE, svg)

// Add question type metadata for further serialization into JSON
Serializer.addClass(
  CUSTOM_TYPE,
  [
    {
      name: 'markdown:html',
      category: 'general',
      default: '',
    },
  ],
  function () {
    return new QuestionMarkdownModel('')
  },
  'nonvalue',
)

export class SurveyQuestionMarkdown extends SurveyQuestionElementBase {
  get question() {
    return this.questionBase
  }

  get markdown() {
    return this.question.markdown
  }

  renderMarkdown(isDesignMode: boolean) {
    if (isDesignMode) {
      return (
        <MarkDownRichTextEditor
          contentEditableClassName="SQMMarkdownInput"
          placeholder="Add text here..."
          onChange={(value) => {
            this.question.setMarkdown(value)
          }}
          markdown={this.question.markdown || ''}
        />
      )
    }
    return <MarkDownConverter className="SQMPreviewType" value={this.question.markdown || ''} />
  }

  renderElement() {
    return <div>{this.renderMarkdown(this.question.isDesignMode)}</div>
  }
}

// Register `SurveyQuestionMarkdown` as a class that renders `text` questions
ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
  return createElement(SurveyQuestionMarkdown, props)
})
